'use client';
/* eslint-disable no-restricted-imports */
import useFeature from '~/client/hooks/feature/useFeature';
import RtpColumn from './RtpColumn';
import GameDetailsContainer from '../GameDetailsContainer';

type Props = { game: GameFragment };

const LiveRtp: FC<Props> = ({ game }) => {
  const isLiveRtpEnabled = useFeature('rtpLive');

  if (!isLiveRtpEnabled) {
    return null;
  }

  return (
    <GameDetailsContainer>
      <RtpColumn
        rtp={game.rtp}
        rtpLive={game.rtpLivePastDay}
        translateId="casino.rtp_24hrtp"
        highlight
      />
      <RtpColumn
        rtp={game.rtp}
        rtpLive={game.rtpLivePastSevenDays}
        translateId="casino.rtp_wk"
      />
      <RtpColumn
        rtp={game.rtp}
        rtpLive={game.rtpLivePastThirtyDays}
        translateId="casino.rtp_mo"
      />
    </GameDetailsContainer>
  );
};

export default LiveRtp;
